var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36.5001C18.5 36.5002 20.5 36.1001 22.5 38.5001C25 41.5001 28 42.9999 30 42.9999C32 42.9999 34 42.4998 36.5 40.4999C39 38.5001 39.5 36.5001 44 36.5001C48.5 36.5001 49.5 42.9999 54.5 42.9999",
    stroke: "#128370",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101 36.5001C100.5 36.5002 98.5 36.1001 96.5 38.5001C94 41.5001 91 42.9999 89 42.9999C87 42.9999 85 42.4998 82.5 40.4999C80 38.5001 79.5 36.5001 75 36.5001C70.5 36.5001 69.5 42.9999 64.5 42.9999",
    stroke: "#128370",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 52.025C18.5 52.0251 20.5 51.625 22.5 54.025C25 57.025 28 58.5248 30 58.5248C32 58.5248 34 58.0247 36.5 56.0248C39 54.025 39.5 52.025 44 52.025C48.5 52.025 49.5 58.5248 54.5 58.5248",
    stroke: "#128370",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101 52.025C100.5 52.0251 98.5 51.625 96.5 54.025C94 57.025 91 58.5248 89 58.5248C87 58.5248 85 58.0247 82.5 56.0248C80 54.025 79.5 52.025 75 52.025C70.5 52.025 69.5 58.5248 64.5 58.5248",
    stroke: "#128370",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 67.5499C18.5 67.55 20.5 67.1499 22.5 69.5499C25 72.5499 28 74.0497 30 74.0497C32 74.0497 34 73.5496 36.5 71.5497C39 69.5499 39.5 67.5499 44 67.5499C48.5 67.5499 49.5 74.0497 54.5 74.0497",
    stroke: "#128370",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101 67.5499C100.5 67.55 98.5 67.1499 96.5 69.5499C94 72.5499 91 74.0497 89 74.0497C87 74.0497 85 73.5496 82.5 71.5497C80 69.5499 79.5 67.5499 75 67.5499C70.5 67.5499 69.5 74.0497 64.5 74.0497",
    stroke: "#128370",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 83.0748C18.5 83.0749 20.5 82.6748 22.5 85.0748C25 88.0748 28 89.5747 30 89.5747C32 89.5747 34 89.0745 36.5 87.0747C39 85.0748 39.5 83.0748 44 83.0748C48.5 83.0748 49.5 89.5747 54.5 89.5747",
    stroke: "#128370",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101 83.0748C100.5 83.0749 98.5 82.6748 96.5 85.0748C94 88.0748 91 89.5747 89 89.5747C87 89.5747 85 89.0745 82.5 87.0747C80 85.0748 79.5 83.0748 75 83.0748C70.5 83.0748 69.5 89.5747 64.5 89.5747",
    stroke: "#128370",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 29.5,
    width: 1,
    height: 1,
    fill: "#128370",
    stroke: "#128370"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 32.5,
    width: 1,
    height: 1,
    fill: "#128370",
    stroke: "#128370"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 47.5,
    width: 1,
    height: 1,
    fill: "#128370",
    stroke: "#128370"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 60.5,
    width: 1,
    height: 1,
    fill: "#128370",
    stroke: "#128370"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 59.5,
    width: 1,
    height: 1,
    fill: "#128370",
    stroke: "#128370"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 80.5,
    width: 1,
    height: 1,
    fill: "#128370",
    stroke: "#128370"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 59.5,
    y1: 24,
    x2: 59.5,
    y2: 97,
    stroke: "#128370",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlux);
export default __webpack_public_path__ + "static/media/Flux.d63b46af1221ca62d0bed22f540e0668.svg";
export { ForwardRef as ReactComponent };